
import React, { Component } from 'react';
import { Modal, Form, DatePicker, Row } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import moment from 'moment';

class ApplyTransferredForm extends Component {

    //回退申请但状态
    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["applicationId"] = this.props.applicationId;
            if(values["collectionTime"] != null){
                values["collectionTime"] = values["collectionTime"].format("YYYY-MM-DD HH:mm:ss");
            }
            http.post({
                url: '/tradeDeduction/saveCollectionTime',
                data: values,
                success: (res) => {
                    messager.notify("保存成功！");
                    this.props.onCancel();
                    this.props.successCallback(this.props.queryData);
                }
            });
        });

    }

    render() {
        const { visible, onCancel, form, collectionTime } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                width={400}
                centered={true}
                visible={visible}
                title="到款时间"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => {
                    this.props.form.resetFields();
                }}
            >
                <Row>
                    <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                        <Form.Item label="到款时间：">
                            {getFieldDecorator('collectionTime', {
                                "initialValue": (collectionTime == null || collectionTime=== "" ? null : moment(collectionTime)),
                                "rules": [
                                    { required: true, message: '到款时间不能为空!' },
                                ]
                            })(<DatePicker format="YYYY-MM-DD HH:mm:ss" showTime={{ format: 'HH:mm:ss' }} style={{ width: '100%' }} />)}
                        </Form.Item>
                    </Form>
                </Row>
            </Modal>
        )
    }
}


const ApplyTransferred = Form.create()(ApplyTransferredForm);

export default ApplyTransferred;